module.exports = __webpack_public_path__ + "static/media/krx-big7-01.6091eb95.jpg";